import React from 'react'
import './Title.css'

export default function Title({ text }) {
  return <h2 className="section-title">{text}</h2>
}
